import Empty from '../../components/Display/Empty'
import Scanning from '../../assets/animations/scanning_ticket.json'
import Button from '../../components/General/Button'
import { FiTrash2 } from 'react-icons/fi'
import InventoryCodeForm from './InventoryCodeForm'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { createAssociated } from '../../redux/actions/items'
import { useDispatch } from 'react-redux'
import { IItem } from '../../common/Inventory/Items'

const AssociatedCode: React.FC<AssociatedCodeProps> = ({
  associatedCodes,
  refDivScrollAssociated = null,
  willErase = true,
  setValueToDelete = () => {},
  setConfirmModalAssociated = () => {},
  cbRequest = () => {}
}) => {
  const { addAlert } = useSnackBars()
  const dispatch = useDispatch()
  
  return (
    <div>
      <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12 text-base">
        Códigos Asociados
      </h1>
      <div className="max-h-80 overflow-y-auto" ref={refDivScrollAssociated}>
        {associatedCodes && associatedCodes.codes.length === 0 && (
          <Empty
            animationProps={{
              height: 200,
              width: 200,
              animation: Scanning,
            }}
            lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
          >
            <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
              Agregar items en un producto compuesto.
            </p>
          </Empty>
        )}

        {associatedCodes && associatedCodes.codes.map((value, index) => (
          <div
            className="rounded-lg mt-4 p-1 flex justify-between items-center border border-primaryGray-700"
            key={index}
          >
            <div>
              <h3 className="text-base ml-3">{value.code}</h3>
            </div>
            <div className="flex">
              {willErase && (
                <Button
                  classes="border-none"
                  onClick={() => {
                    setValueToDelete(value.id)
                    setConfirmModalAssociated(true)
                  }}
                >
                  <FiTrash2 size={20} className='text-primary-700' />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
      <InventoryCodeForm
        onPropSubmitCode={
          async (value) => {
            try {
              if (associatedCodes) {
                const response : any = await dispatch(
                  createAssociated({
                    code: value,
                    item: { id: associatedCodes.idItem },
                  })
                )
                const { id } = response.data.associatedCode
                cbRequest({ id, code: value})
              }
              // console.log(response)
            } catch (e: any) {
              if (e.response.status === 400) {
                if (e.response.data.message === "Code already exists") {
                  addAlert({
                    message: "El código ya existe",
                    status: 'error',
                  })
                }
              } else {
                addAlert({
                  message: "Error de servidor",
                  status: 'error',
                })
              }
            } finally {
              if (refDivScrollAssociated) {
                refDivScrollAssociated.current?.scrollTo(0, 0)
              }
            }
          }
          // setArrayOfAssociates((prevValue) => [
          //   ...prevValue,
          //   { id: 0, code: value },
          // ])
        }
      />
    </div>
  )
}

interface AssociatedCodeProps {
  // items: IItem[]
  // edit: IItem
  refDivScrollAssociated?: React.MutableRefObject<HTMLDivElement | null>
  willErase?: boolean
  setValueToDelete?: Function
  setConfirmModalAssociated?: Function
  cbRequest?: Function
  associatedCodes: IAssociatedCodes | undefined
}

export interface IAssociatedCodes {
  idItem: string
  codes: {code: string; id: string}[]
}

export default AssociatedCode